<div class="py-4 container-fluid schedule-submissions-page">
  <h4 class="mb-4 schedule-submissions-title">
    {{ pageTitle() }}
  </h4>

  <div class="schedule-submissions-card">
    <div class="schedule-submissions-card-body">
      <div class="schedule-submissions-toolbar" [formGroup]="form">
        <div class="schedule-submissions-filters">
          <div class="schedule-submissions-filter">
            <app-select
              label="เทอมการศึกษา"
              formControlName="academicTerm"
              [options]="academicTermOptions"
              [searchable]="false"
              [clearable]="false"
              inputClass="schedule-submissions-select"
              classes="mb-0"
            ></app-select>
          </div>

          <div class="schedule-submissions-filter">
            <app-select
              label="ปีการศึกษา"
              formControlName="year"
              [options]="yearOptions"
              [searchable]="false"
              [clearable]="false"
              inputClass="schedule-submissions-select"
              classes="mb-0"
            ></app-select>
          </div>

          <div
            class="schedule-submissions-search-filter"
            [style.visibility]="canViewManagerFilters() ? 'visible' : 'hidden'"
            [attr.aria-hidden]="!canViewManagerFilters()"
          >
            <app-filter-search-input
              label="ตำแหน่งทางวิชาการ, ชื่อ - นามสกุล"
              formControlName="keyword"
              inputClass="schedule-submissions-search-input"
              classes="mb-0"
              ariaLabel="ค้นหาตารางสอน"
              (searchSubmit)="onSearch()"
            ></app-filter-search-input>
          </div>

          <div
            class="schedule-submissions-filter"
            [style.visibility]="canViewManagerFilters() ? 'visible' : 'hidden'"
            [attr.aria-hidden]="!canViewManagerFilters()"
          >
            <app-select
              label="สาขาวิชา"
              formControlName="departmentId"
              [options]="departmentOptions"
              bindLabel="name"
              bindValue="id"
              [searchable]="false"
              inputClass="schedule-submissions-select"
              classes="mb-0"
            ></app-select>
          </div>
        </div>
      </div>

      <div
        *ngIf="canShowBulkEducationHeadConfirm()"
        class="schedule-submissions-bulk-toolbar"
      >
        <span class="schedule-submissions-bulk-count">
          เลือกแล้ว {{ selectedBulkEducationHeadConfirmCount() }} รายการ
        </span>
        <button
          type="button"
          class="btn schedule-submissions-bulk-confirm-button"
          [disabled]="!canBulkEducationHeadConfirm()"
          [attr.aria-disabled]="!canBulkEducationHeadConfirm()"
          (click)="onOpenBulkEducationHeadConfirm()"
        >
          รับรอง
        </button>
      </div>

      <div
        *ngIf="bulkConfirmResultMessage()"
        class="schedule-submissions-bulk-result"
      >
        {{ bulkConfirmResultMessage() }}
      </div>

      <ng-template #rowIndexTemplate let-row="row">
        {{ row.sequence ?? '-' }}
      </ng-template>

      <ng-template #bulkSelectHeaderTemplate>
        <input
          type="checkbox"
          class="schedule-submissions-bulk-checkbox"
          aria-label="เลือกตารางสอนทั้งหมดในหน้านี้"
          [checked]="isAllCurrentPageBulkSelected()"
          [indeterminate]="isSomeCurrentPageBulkSelected() && !isAllCurrentPageBulkSelected()"
          (change)="onToggleBulkSelectAllCurrentPage($any($event.target).checked)"
        />
      </ng-template>

      <ng-template #bulkSelectCellTemplate let-row="row">
        <input
          type="checkbox"
          class="schedule-submissions-bulk-checkbox"
          aria-label="เลือกตารางสอน"
          [checked]="isBulkSelected(row)"
          [disabled]="!canSelectForBulkEducationHeadConfirm(row)"
          (change)="onToggleBulkSelection(row, $any($event.target).checked)"
        />
      </ng-template>

      <ng-template #statusTemplate let-row="row">
        <span
          class="schedule-submissions-status-badge"
          [class.schedule-submissions-status-badge-special-revision]="isSpecialRevisionStatus(row.statusCode)"
          [class.schedule-submissions-status-badge-revision]="isRevisionStatus(row.statusCode)"
          [class.schedule-submissions-status-badge-pending]="isPendingStatus(row.statusCode)"
          [class.schedule-submissions-status-badge-completed]="isCompletedStatus(row.statusCode)"
          [class.schedule-submissions-status-badge-waiting-submit]="isWaitingTeacherSubmitStatus(row.statusCode)"
          [class.schedule-submissions-status-badge-waiting-review]="isWaitingEducationHeadReviewStatus(row.statusCode)"
        >
          {{ row.statusLabel }}
        </span>
      </ng-template>

      <ng-template #actionTemplate let-row="row">
        <div class="schedule-submissions-actions">
          <button
            type="button"
            class="btn schedule-submissions-action-button datatable-view-action-button"
            aria-label="ดูตารางสอน"
            (click)="onViewSubmission(row)"
          >
            <img
              src="assets/media/icons/svg/eye.svg"
              class="schedule-submissions-action-icon datatable-view-action-icon"
              alt=""
              aria-hidden="true"
            />
          </button>
        </div>
      </ng-template>

      <app-datatable
        [datasource]="datasource()"
        [columns]="columns"
        [isLoading]="tableLoading()"
        [limit]="10"
        [showOrder]="false"
        (sortChange)="onSortChange($event)"
      ></app-datatable>

      <app-table-pagination
        [page]="datasource().page"
        [limit]="datasource().limit"
        [total]="datasource().total"
        [totalPage]="datasource().total_page"
        [offset]="datasource().offset"
        [dataLength]="datasource().data.length"
        [isLoading]="tableLoading()"
        [pageSizeOptions]="pageSizeOptions"
        ariaLabel="schedule submissions pagination"
        (pageChange)="onPageChange($event)"
        (limitChange)="onLimitChange($event)"
      ></app-table-pagination>
    </div>
  </div>

  <div
    *ngIf="bulkConfirmModalOpen()"
    class="schedule-submissions-confirm-backdrop"
  >
    <section
      class="schedule-submissions-confirm-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="schedule-submissions-bulk-confirm-title"
    >
      <div class="schedule-submissions-confirm-icon" aria-hidden="true">!</div>
      <h5 id="schedule-submissions-bulk-confirm-title">ยืนยันการรับรอง</h5>
      <p>
        ต้องการรับรองตารางสอนที่เลือกจำนวน {{ selectedBulkEducationHeadConfirmIds().length }} รายการใช่หรือไม่?
      </p>
      <p>
        ระบบจะรับรองรายวิชาที่รอพิจารณาทั้งหมด และยืนยันตารางสอนให้เสร็จสิ้น
      </p>
      <footer class="schedule-submissions-confirm-footer">
        <button
          type="button"
          class="btn schedule-submissions-cancel-button"
          [disabled]="bulkConfirmLoading()"
          (click)="onCloseBulkEducationHeadConfirm()"
        >
          ยกเลิก
        </button>
        <button
          type="button"
          class="btn schedule-submissions-bulk-confirm-button"
          [disabled]="bulkConfirmLoading()"
          (click)="onConfirmBulkEducationHeadConfirm()"
        >
          ยืนยัน
        </button>
      </footer>
    </section>
  </div>
</div>
